module.exports = __webpack_public_path__ + "media/parfait.10f80eed.mp4";